export var getMenuData = [
  {
    category: true,
    title: 'Concesiones',
  },
  {
    title: 'Concesiones',
    key: 'dashboards',
    icon: 'fe fe-home',
    // roles: ['admin'], // set user roles with access to this route
    // count: 4,
    children: [
      {
        title: 'Concesiones',
        key: 'concessiones',
        url: '/concesiones/getConcessions',
      },
    ],
  },
  {
    category: true,
    title: 'CONDUCTORES',
  },
  {
    title: 'Conductores',
    key: 'conductores',
    icon: 'fe fe-user',
    children: [
      {
        title: 'Conductores',
        key: 'conductorbuscar',
        url: '/conductores/getDrivers',
      },
    ],
  },
  {
    category: true,
    title: 'Mapa de localización',
  },
  {
    title: 'Mapa de localización',
    key: 'mapa',
    icon: 'fa fa-user',
    children: [
      {
        category: false,
        title: 'Mapa de localización',
        key: 'map',
        url: '/mapa',
      },
    ],
  },
  /* {
    category: true,
    title: 'Viajes',
  },
  {
    title: 'Viajes',
    key: 'viajes',
    icon: 'fa fa-user',
    children: [
      {
        title: 'Viajes',
        key: 'viajesbuscar',
        url: '/trips/getTrips',
      },
    ],
  }, */
  /*
  {
    category: true,
    title: 'MÉTODOS DE PAGO',
  },
  {
    title: 'Métodos de pago',
    key: 'paymentMethods',
    icon: 'fe fe-credit-card',
    children: [
      {
        title: 'Métodos de pago',
        key: 'savedPaymentMethods',
        url: '/metodosdepago',
      },
    ],
  }, */
]
